/* eslint-disable @typescript-eslint/no-shadow */
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CancelarRequestService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

  cancelRequest(processId: string): Promise<any> {
    const url = `https://api.legislapp.com.br/Request/Cancelar?processId=${processId}`;

    return new Promise((resolve, reject) => {
      this.http.post(url, null).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error),
      });
    });
  }
}
